import Vue from 'vue'
import {
  Button,
  Select,
  Option,
  Empty,
  Calendar,
  Checkbox,
  Input,
  Upload,
  Table,
  TableColumn,
  Image,
  Pagination,
  Row,
  Icon,
  Dialog,
  popover
} from 'element-ui'
// 或写为
Vue.use(Button)
Vue.use(popover)
Vue.use(Empty)
Vue.use(Calendar)
Vue.use(Checkbox)
Vue.use(Input)
Vue.use(Upload)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Image)
Vue.use(Select)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Row)
Vue.use(Icon)
Vue.use(Dialog)